import React from 'react';
import classNames from 'classnames';
import CSSModules from 'react-css-modules';
import config from 'config';
import styles from './DonateButton.scss';
import { enrol } from 'src/helpers/api/ab';

type Props = {
  isActive: boolean;
  name: string;
  pageSection: string;
  isEnrolledInDonateNow?: boolean;
  donate: (options: { pageSection: string }) => void;
};

interface State {
  isEnrolledInDonateNow?: boolean;
}

class DonateButton extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      isEnrolledInDonateNow: this.props.isEnrolledInDonateNow,
    };
  }

  async componentDidMount() {
    if (this.state.isEnrolledInDonateNow === undefined) {
      const variation = await enrol('growth_donate_now_button');
      this.setState({ isEnrolledInDonateNow: variation === 'B' });
    }
  }

  render() {
    const { isActive, name, pageSection, donate } = this.props;

    const buttonClass = classNames('jg-btn', {
      'is-disabled': !isActive,
    });

    const enrolledSlugs = Buffer.from(
      '["growth_donate_now_button", "cf_growth_remind_me_later", "cf_growth_share_button_modal", "cf_growth_be_my_first_donor", "cf_growth_help_share_my_story"]'
    ).toString('base64');
    return (
      <a
        data-marker="donate-button"
        onClick={() => donate({ pageSection })}
        href={`${
          config.CROWDFUNDING_BASE_URI
        }/${name}/donate?pageSection=${pageSection}&enrol=${enrolledSlugs}`}
        className={buttonClass}
        styleName="fixed-donate-button"
      >
        {this.state.isEnrolledInDonateNow ? 'Donate Now' : 'Donate'}
      </a>
    );
  }
}

export default CSSModules(DonateButton, styles);



// WEBPACK FOOTER //
// ./src/components/Page/DonateButton.tsx